module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_1_01_thumb.9104a065.png";